import type { SamlIdentityProvider } from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';
import { useDAL } from '@/contexts/useDAL';

import { UpsertSamlFlow, type UpsertSamlState } from './upsertSamlFlow';

interface SamlPanelProps {
  entity: SamlIdentityProvider;
  onSave: () => Promise<void>;
  onAbort: () => void;
}

export const SamlPanel = (props: SamlPanelProps) => {
  const dal = useDAL();

  const save = async (state: UpsertSamlState) => {
    if (state.id) {
      await dal.saml.update(state.id, state);
    } else {
      await dal.saml.create(state);
    }
    await props.onSave();
    return true;
  };

  return (
    <Wizard<UpsertSamlState>
      hideBackArrow={true}
      onAbort={props.onAbort}
      onFinish={save}
      flow={[UpsertSamlFlow]}
      initialState={{
        ...props.entity,
      }}
      title={
        props.entity.id
          ? 'Edit SAML Configuration'
          : 'Create SAML Configuration'
      }
    />
  );
};
